import axios from "axios";
import { headersProvider, masterApiHeader } from "../apiHelpers";
import constants from "../constants";

export const usersLogin = ({ accessToken }) =>
  axios.post(
    `${constants.utilityHost}/users/login`,
    {
      accessToken,
    },
    {
      headers: headersProvider(),
      noTrailingSlash: true,
    }
  );

export const usersMSLogin = ({ accessToken }) =>
  axios.post(
    `${constants.utilityHost}/users/mslogin`,
    {
      accessToken,
    },
    {
      headers: headersProvider(),
      noTrailingSlash: true,
    }
  );

export const userDetails = () =>
  axios.get(`${constants.masterApi}/email/service/user/details`, {
    headers: headersProvider(),
  });

export const workspaceUsers = () =>
  axios.get(`${constants.masterApi}/email/service/user/workspace-users-list/`, {
    headers: headersProvider(),
  });
export const changeUserRole = (roleId) =>
  axios.get(`${constants.masterApi}/email/service/user/login-as/${roleId}`, {
    headers: headersProvider(),
  });

export const getSelfNotifications = ({
  take,
  page,
  sortByOptions,
  filterOptions,
}) =>
  axios.post(
    `${constants.utilityHost}/notifications/self`,
    {
      page,
      take,
      sortByOptions,
      filterOptions,
    },
    {
      headers: headersProvider(),
    }
  );

export const getDashboardTAT = ({ month }) =>
  axios.get(`${constants.utilityHost}/dashboard/sla/${month}`, {
    headers: headersProvider(),
  });

export const getUnseenNotifications = () =>
  axios.get(`${constants.utilityHost}/unseenCount`, {
    headers: headersProvider(),
  });

export const updateNotificationStatus = ({ id }) =>
  axios.put(
    `${constants.utilityHost}/makeseen`,
    {
      id,
    },
    {
      headers: headersProvider(),
    }
  );
export const getDepartmentList = () =>
  axios.get(`${constants.masterApi}/email/service/user/department-list`, {
    headers: headersProvider(),
  });

export const getAllBuList = () =>
  axios.get(`${constants.masterApi}/email/service/user/all-bu-list`, {
    headers: headersProvider(),
  });

export const getBuList = () =>
  axios.get(`${constants.masterApi}/email/service/user/bu-list`, {
    headers: headersProvider(),
  });

export const getUserRoleList = () =>
  axios.get(`${constants.masterApi}/email/service/user/user-role-list`, {
    headers: headersProvider(),
  });

export const getModuleList = () =>
  axios.get(`${constants.masterApi}/email/service/user/module-list`, {
    headers: headersProvider(),
  });
export const addBuApi = ({ buData }) =>
  axios.post(
    `${constants.masterApi}/email/service/user/bu-save`,
    {
      ...buData,
    },
    {
      headers: headersProvider(),
    }
  );
export const updateBuApi = ({ buData }) =>
  axios.put(
    `${constants.masterApi}/email/service/user/update-bu`,
    {
      ...buData,
    },
    {
      headers: headersProvider(),
    }
  );

export const getUserFromMaster = () =>
  axios.get(`${constants.masterApi}/email/service/user/user-list`, {
    headers: headersProvider(),
  });
export const addMasterUser = ({ userData }) =>
  axios.post(
    `${constants.masterApi}/email/service/user/register-new-user`,
    {
      ...userData,
    },
    {
      headers: masterApiHeader(),
    }
  );

export const updateMasterUser = ({ userData }) =>
  axios.post(
    `${constants.masterApi}/email/service/user/update-user`,
    {
      ...userData,
    },
    {
      headers: masterApiHeader(),
    }
  );

export const getBuDetails = ({ id }) =>
  axios.post(
    `${constants.masterApi}/email/service/user/budetails`,
    {
      id,
    },
    {
      headers: masterApiHeader(),
    }
  );
export const getOrgDetailsFromMaster = () =>
  axios.post(
    `${constants.masterApi}/email/service/user/orgdetails`,
    { id: 1 },
    {
      headers: masterApiHeader(),
    }
  );
